var get = require("object-path").get;

module.exports = function(mediaItem) {
    var generation = mediaItem;

    while (get(generation, "parent", null)) {
        generation = get(generation, "parent", null);
    }

    return generation !== mediaItem ? generation : null;
};
